<main class="main-login-container">
  <section class="logo-container">
    <img alt="logotipo da cristália" src="assets/img/logo_cristalia_short.png">
  </section>
  <div class="content-login">
    <div class="logo-cristalia-container">
      <img alt="logotipo da cristália PRO Hospitalar" src="assets/img/app_logo.png" width="200">
    </div>
    <p-card class="card-container-login">
      <form (ngSubmit)="loginSubmit()" [formGroup]="loginForm">
        <div>
          <p-floatlabel variant="in">
            <input fluid formControlName="email" id="email" pInputText type="text">
            <label for="email">Email</label>
          </p-floatlabel>
          @if (loginForm.get('email')?.invalid && (loginForm.get('email')?.touched || loginForm.get('email')?.dirty)) {
            <p-message severity="error" size="small" variant="simple">
              @if (loginForm.get('email')?.hasError('required')) {
                Campo obrigatório
              }
              @if (loginForm.get('email')?.hasError('email')) {
                Email inválido
              }
            </p-message>
          }
        </div>
        <div>
          <p-floatlabel variant="in">
            <p-password [feedback]="false" [toggleMask]="true" fluid formControlName="password"
                        inputId="password"></p-password>
            <label for="password">Senha</label>
          </p-floatlabel>
          @if (loginForm.get('password')?.invalid && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)) {
            <p-message severity="error" size="small" variant="simple">
              @if (loginForm.get('password')?.hasError('required')) {
                Campo obrigatório
              }
            </p-message>
          }
        </div>

        <p-button [loading]="isLoading" fluid label="Entrar" severity="info"
                  type="submit"></p-button>
      </form>
    </p-card>
  </div>
</main>
